import { AppQueryParams } from '@doda/common/src/constants/queryParams';
import { AreaListOfSearchModal } from '@doda/common/src/models/MasterCacheModel';
import { NATIONAL_AREA_NUMBER } from '@doda/common/src/constants/properties/const';

/**
 * エリアのAPIリクエスト作成
 * @param queryParams クエリパラメータ
 * @param areas エリアのマスタ
 * @returns エリアのAPIリクエスト
 */
export const createAreasApiRequest = (
  queryParams: AppQueryParams,
  areas: AreaListOfSearchModal[] | null
) => {
  let areaName = '';
  let ar = '';
  let requestAreaId: string[] | undefined = [];

  if (queryParams.ar) [ar] = queryParams.ar;
  const findAr = areas?.find((area) => area.id === ar);
  if (findAr && ar !== NATIONAL_AREA_NUMBER) {
    areaName = findAr.name;
    requestAreaId = queryParams.ar;
  } else {
    // マスタに存在する値かの判定
    throw new Error('パラメータの不正(ar)');
  }

  return { areaName, requestAreaId };
};
